import { FileInfoDisplayResultDto } from '../../_models/file-info-display-result-dto';

export class WorkOrderDocumentResultDto extends FileInfoDisplayResultDto {
    allowDelete: boolean;
}
